export { ProductDetail } from './ProductDetail';
